exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.accountsTab .avatarRowWidth {\n  width: 100px;\n}\n.accountsTab .avataHolder {\n  width: 62px;\n  height: 62px;\n}\n.accountsTab .avatarHolder {\n  width: 62px;\n  height: 62px;\n  background-position: center;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7651af25","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/settings/TabAccounts.vue
// module id = 2557
// module chunks = 0